import { render, staticRenderFns } from "./mwPoster.vue?vue&type=template&id=87e592f0&scoped=true"
import script from "./mwPoster.vue?vue&type=script&lang=js"
export * from "./mwPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e592f0",
  null
  
)

export default component.exports